import React from "react";
import { withRouter } from "react-router-dom";
import { Row, Col } from "antd";
import PropTypes from 'prop-types';
import { filterCountryData, filterStateData } from "../../../../../../../MyAccounts/Components/Data/DropDownData";
import { ContribType, ContributionName, ComponentDivider } from "./styles";
import { LetterOfAuthorization, AuthorizationText, FontBoldText, ContentWrap, ContentSubList } from "../FundingInstructions/styles";
import { connect } from "react-redux";
import formatter from "../../../../../../../../utils/formatter";
import { milliToDate, milliToTime, todayDate } from "../../../../../../../../utils/commonUtil";
import MultiContribution from "./Components/MultiContribution";
import { contributionTypeState } from "../../../../selectors";


const removePeriod = (address) => {
  const trimmedAddr = address.trim();
  return trimmedAddr[trimmedAddr.length - 1] === '.' ? trimmedAddr.substring(0, trimmedAddr.length - 1) : trimmedAddr;
}

export class ContributionType extends React.Component {
  constructor(props) {
    super(props);
  }

  numberFormatter = (value) => {
    return parseFloat(
      value
    ).toLocaleString(undefined, {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4
    });
  }

  renderSingleLot = (singleLot) => {
    const lotDetails = {
      securityName: singleLot.name , 
      ticker: singleLot.ticker, 
      shares: singleLot.lot && singleLot.lot.shares ? this.numberFormatter(singleLot.lot.shares) : '', 
      salePrice: singleLot.lot && singleLot.lot.settlement && singleLot.lot.settlement.price ? '$'+this.numberFormatter(singleLot.lot.settlement.price) : '', 
      saleFee: singleLot.lot && singleLot.lot.settlement && singleLot.lot.settlement.commissionFees ? formatter({ value: singleLot.lot.settlement.commissionFees,fieldSuffix: "Dollars"}) : '', 
      processingFee: singleLot.lot && singleLot.lot.settlement && singleLot.lot.settlement.otherFees ? formatter({ value: singleLot.lot.settlement.otherFees,fieldSuffix: "Dollars"}) : '', 
      netProceeds: singleLot.lot && singleLot.lot.settlement && singleLot.lot.settlement.netProceeds ? formatter({ value: singleLot.lot.settlement.netProceeds,fieldSuffix: "Dollars"}) : '', 
      saleDate: singleLot.soldDate ? milliToDate(Number(singleLot.soldDate)) : '', 
      settlementDate: singleLot.lot && singleLot.lot.settlement && singleLot.lot.settlement.settlementDate ? milliToDate(Number(singleLot.lot.settlement.settlementDate)) : ''
    }
    return <MultiContribution lotDetails={lotDetails} />
  }

  // Check special assets with entered status
  showReceivedDate = (name, contribution) => {
    let { giftStatus } = contribution;
    return name === "Special Asset" && giftStatus && giftStatus.extDescription === "Entered" ? <div>&mdash;</div> : contribution.receiveDateStr
  }

  renderContributionTypes = (
    contribution,
    name,
    donorDisplayName,
    loggedInAddress,
    count,
    contributionTypes
  ) => {
    let address = {};
    let donorAddress = {};
    let donorType = "";
    let loggedInUserName = "";
    let donorUserName = "";
    let newType = '';
    let isTypeChange = false;
    let sharesVisible = true;
    let isMutualStp = false;
    let isSettlementFund = false;
    if (contribution.donorType == "I") {
      donorType = "Individual";
      address = loggedInAddress;
      loggedInUserName = donorDisplayName;
    } else if (contribution.donorType == "J") {
      donorType = "Joint";
      address = loggedInAddress;
      donorAddress = contribution.donorAddress;
      loggedInUserName = donorDisplayName;
      donorUserName =
        (contribution.donorFirstName ? contribution.donorFirstName : "") +
        (contribution.donorLastName ? " " + contribution.donorLastName : "");
    } else if (contribution.donorType == "30") {
      donorType = "Trust";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    } else if (contribution.donorType == "10") {
      donorType = "Corporation";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    } else if (contribution.donorType == "20") {
      donorType = "Private Foundation";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    } else if (contribution.donorType == "70") {
      donorType = "Other donor-advised Fund";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    } else if(contribution.donorType == "40"){
      donorType = "Other";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    } else if(contribution.donorType == "50"){
      donorType = "Estate";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    } else if(contribution.donorType == "60"){
      donorType = "Public Charity";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    } else if(contribution.donorType == "80"){
      donorType = "Government Grant/Contract";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    } else if(contribution.donorType == "90"){
      donorType = "Non-Charitable Tax-Exempt Organization";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    } else if(contribution.donorType == "100"){
      donorType = "Church/School/Medical Institution";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    } else if(contribution.donorType == "110"){
      donorType = "Partnership";
      address = loggedInAddress;
      donorAddress = contribution.donorOrgAddress;
      loggedInUserName = donorDisplayName;
      donorUserName = contribution.donorOrgName;
    }

    if (contribution.stpWorkflow && contribution.stpWorkflow == "Y") {
      if (contribution.donorType == "I") {
        donorType = "Individual";
        address = contributionTypes.vgiAddressDetails;
        loggedInUserName = donorDisplayName;
      } else if (contribution.donorType == "J") {
        donorType = "Joint";
        donorAddress = contributionTypes.vgiAddressDetails;
        donorUserName = contributionTypes.vgiJointDonor
          ? contributionTypes.vgiJointDonor
          : "";
      } else if (contribution.donorType == "30") {
        donorType = "Trust";
        donorAddress = contributionTypes.vgiAddressDetails;
        donorUserName =
          (contributionTypes.vgiTrustName
            ? contributionTypes.vgiTrustName
            : "") +
          (contributionTypes.vgiJointTrustee
            ? ", " + contributionTypes.vgiJointTrustee
            : "");
      }
    }

    let line1 = address ? (address.line1 ? address.line1 + ", " : "") : "";
    let line2 = address ? (address.line2 ? address.line2 + ", " : "") : "";
    let line3 = address ? (address.line3 ? address.line3 + ", " : "") : "";
    let city = address ? (address.city ? address.city + ", " : "") : "";
    let state = address
      ? address.state
        ? (address.country == "0"
            ? this.props.dropDownData
              ? filterStateData(
                  address.state,
                  this.props.dropDownData.states
                ).map(val => val.desc)
              : address.state
            : address.state) + ", "
        : ""
      : "";
    let country = address
      ? address.country
        ? this.props.dropDownData
          ? filterCountryData(
              address.country,
              this.props.dropDownData.countries
            ).map(val => val.desc) + ", "
          : address.country + ", "
        : ""
      : "";
    let zip = address ? (address.zip ? address.zip + ". " : "") : "";
    let type = address ? (address.addrType ? address.addrType.codeId : "") : "";
    let addressType = "";
    if (type !== "") {
      if (type == "1000") {
        addressType = "Business";
      } else if (type == "1001") {
        addressType = "Home";
      } else if (type == "1002") {
        addressType = "Mailing";
      } else if (type == "1003") {
        addressType = "Physical";
      } else if (type == "1004") {
        addressType = "Summer";
      } else if (type == "1005") {
        addressType = "Winter";
      } else if (type == "1006") {
        addressType = "Other";
      } else {
        addressType = <div>&mdash;</div>
      }
    } else {
      addressType = <div>&mdash;</div>
    }
    let address1 = line1 + line2 + line3;
    let address2 = city + state + country + zip;
    let donorline1 = donorAddress
      ? donorAddress.line1
        ? donorAddress.line1 + ", "
        : ""
      : "";
    let donorline2 = donorAddress
      ? donorAddress.line2
        ? donorAddress.line2 + ", "
        : ""
      : "";
    let donorline3 = donorAddress
      ? donorAddress.line3
        ? donorAddress.line3 + ", "
        : ""
      : "";
    let donorcity = donorAddress
      ? donorAddress.city
        ? donorAddress.city + ", "
        : ""
      : "";
    let donorstate = donorAddress
      ? donorAddress.state
        ? (donorAddress.country == "0"
            ? this.props.dropDownData
              ? filterStateData(
                  donorAddress.state,
                  this.props.dropDownData.states
                ).map(val => val.desc)
              : donorAddress.state
            : donorAddress.state) + ", "
        : ""
      : "";
    let donorcountry = donorAddress
      ? donorAddress.country
        ? this.props.dropDownData
          ? filterCountryData(
              donorAddress.country,
              this.props.dropDownData.countries
            ).map(val => val.desc) + ", "
          : donorAddress.country + ", "
        : ""
      : "";
    let donorzip = donorAddress
      ? donorAddress.zip
        ? donorAddress.zip + ". "
        : ""
      : "";
      let donoraaddressType = donorAddress
      ? donorAddress.addrType
        ? donorAddress.addrType.codeId
        : ""
      : "";
    let donoraddressType = "";
    if (donoraaddressType !== "") {
      if (donoraaddressType == "1000") {
        donoraddressType = "Business";
      } else if (donoraaddressType == "1001") {
        donoraddressType = "Home";
      } else if (donoraaddressType == "1002") {
        donoraddressType = "Mailing";
      } else if (donoraaddressType == "1003") {
        donoraddressType = "Physical";
      } else if (donoraaddressType == "1004") {
        donoraddressType = "Summer";
      } else if (donoraaddressType == "1005") {
        donoraddressType = "Winter";
      } else if (donoraaddressType == "1006") {
        donoraddressType = "Other";
      } else {
        donoraddressType = <div>&mdash;</div>
      }
    } else {
      donoraddressType = <div>&mdash;</div>
    }
    
    let donoraddress1 = donorline1 + donorline2 + donorline3;
    let donoraddress2 = donorcity + donorstate + donorcountry + donorzip;
    let settleDate = null;
    if (name == "Securities") {
      let origin = contribution.origination;
      if (origin) {
        if (origin.codeType == "SECURITY_ORIGINATION") {
          if (origin.codeValue == "10" || origin.codeValue == "40") {
            name = "Asset Held at Vanguard - Securities";
          } else if (origin.codeValue == "20") {
            name = "Asset Held Outside Vanguard - Securities";
          } else if (origin.codeValue == "30") {
            name = "Stock Certificates";
          }
        }
      }
      if (contribution.nonVBSMutualFundFlag) {
        name = "Asset Held Outside Vanguard - Mutual Funds";
      }
      if(contribution.stpWorkflow === "Y"){
        name = 'Asset Held at Vanguard - Securities';
        newType = 'VBS Security';
        isTypeChange = true;
      }
      
    } else if (name == "Funds") {
      let origin = contribution.origination;
      if (origin) {
        if (origin.codeValue == "10" || origin.codeValue == "20") {
          name = "Asset Held at Vanguard - Mutual Funds";
        } else if (origin.codeValue == "30") {
          name = "Asset Held Outside Vanguard - Mutual Funds";
        }
        
        if(contribution.stpWorkflow === "Y") {
          newType = 'Mutual Fund';
          isTypeChange = true;
          if(contribution.allShares){
              isMutualStp = true;
          }else{
            sharesVisible = false;
          }
        }
      }
    }

    if(name == "Wire"){
        if(contribution.stpWorkflow == "Y"){
          newType = "Settlement Fund";
          name = 'Asset Held at Vanguard - Mutual Funds';
          isSettlementFund = true;
          isTypeChange = true;
          if(contribution.allShares){
            isMutualStp = true;
        }else{
          sharesVisible = false;
        }
        }
    }

    if(name === "Asset Held Outside Vanguard - Securities" || name === "Asset Held at Vanguard - Securities" || name === "Stock Certificates"){
      if(contribution.lotDetails && contribution.lotDetails[0] && contribution.lotDetails[0].lot && contribution.lotDetails[0].lot["settlement"] && contribution.lotDetails[0].lot["settlement"].settlementDate){
        settleDate = contribution.lotDetails[0].lot["settlement"].settlementDate;
      }
    }else{
      settleDate = contribution.settlementDate ? contribution.settlementDate :null;
    }
    const lotDetails = contribution.lotDetails && contribution.lotDetails[0] && contribution.lotDetails[0].lot && contribution.lotDetails[0].lot["settlement"];
    const soldDate = contribution.lotDetails && contribution.lotDetails[0] && contribution.lotDetails[0]["soldDate"];
    let donorName = contribution.name;
    const tickerValidations = ['Asset Held at Vanguard - Mutual Funds','Asset Held Outside Vanguard - Mutual Funds','Asset Held at Vanguard - Securities','Asset Held Outside Vanguard - Securities','Stock Certificates'];
    const dollarAmount = contribution.amount ? formatter({
      value: contribution.amount,
      fieldSuffix: "Dollars"
    }) : null;
    const transactionStatus = contribution.giftStatus && contribution.giftStatus.extDescription;
    const showAction = (transactionStatus && contribution.nigoReasonCode && contribution.nigoReasonCode.description && (transactionStatus.toLowerCase() === 'pending review' || transactionStatus.toLowerCase() === 'assets needed')) || contribution.assetsNeededStatus;
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    let actionNeeded = '';
    if(showAction){
        if((name === 'Asset Held at Vanguard - Securities' && !userData.csrUser) || (name === 'Asset Held at Vanguard - Mutual Funds' && !userData.csrUser)){
          actionNeeded = contribution.nigoReasonCode.description;
          if(contribution.nigoReasonCode.description.toLowerCase() === 'loa needed for vbs security' || 
             contribution.nigoReasonCode.description.toLowerCase() === 'loa needed for ta') {
            actionNeeded = 'Letter of Authorization needed';
          }
        } else {            
            actionNeeded = contribution.assetsNeededStatus ? 'Assets Needed - View Funding Instructions' : contribution.nigoReasonCode.description;
        }
    }
    const isMultiLot = contribution.lotDetails && contribution.lotDetails.length && ['Asset Held at Vanguard - Securities','Asset Held Outside Vanguard - Securities','Stock Certificates'].includes(name) && ['assets sold','assets received', 'assets pending settlement','completed'].includes(transactionStatus.toLowerCase());
    return ( 
      <div>
        { isTypeChange && newType === 'Mutual Fund' || newType === 'Settlement Fund' ?
        <LetterOfAuthorization width='true' className='mb-20'>
          
          Please note: Contributions of assets held at Vanguard received after the following trade cutoff times will be processed the following business day.
          <ContentSubList>
         <li> <ContentWrap ><FontBoldText>4:00 p.m., Eastern time:</FontBoldText> Trade cutoff for contributions of assets held at Vanguard, except in instances of early market close.</ContentWrap></li>
         <li> <ContentWrap ><FontBoldText>2:00 p.m., Eastern time:</FontBoldText> Trade cutoff for contributions of assets held at Vanguard and requiring a Letter of Authorization, except in instances of early market close. Contributions requiring a Letter of Authorization include account registrations that are not individual, joint or trust.</ContentWrap></li>
         </ContentSubList>
          <ContentWrap className="mt-20 mb-25" mL='0'>Date and time of receipt: <FontBoldText>{contribution.createdDate ? milliToDate(Number(contribution.createdDate)): todayDate()} at {contribution.createdDate ? milliToTime(Number(contribution.createdDate)) : '2:00 PM'}, EDT</FontBoldText></ContentWrap>
          <AuthorizationText><FontBoldText>Donor</FontBoldText> is the individual responsible for this transaction on the referenced Vanguard Charitable account. <FontBoldText>Donor information</FontBoldText> applies to the individual(s) who will receive a tax substantiation letter for this contribution. If this information is not correct please call Vanguard Charitable for assistance at <FontBoldText>888-383-4483.</FontBoldText></AuthorizationText>
          
        </LetterOfAuthorization>  
        : '' }
        {isTypeChange && newType === 'VBS Security' ?
        <LetterOfAuthorization width='true' className='mb-20'>
          <AuthorizationText><FontBoldText>Donor</FontBoldText> is the individual responsible for this transaction on the referenced Vanguard Charitable account. <FontBoldText>Donor information</FontBoldText> applies to the individual(s) who will receive a tax substantiation letter for this contribution. If this information is not correct please call Vanguard Charitable for assistance at <FontBoldText>888-383-4483.</FontBoldText></AuthorizationText>
        </LetterOfAuthorization>  
        : '' }
        { !isTypeChange && name === 'Asset Held at Vanguard - Mutual Funds' ?
        <LetterOfAuthorization width='true' className='mb-20'>
          <div>Please note: contributions of Vanguard Mutual Funds that are received after the trade cutoff will be processed the following business day. Contributions cannot be processed until the Letter of Authorization is received by Vanguard Charitable. The trade cutoff for <FontBoldText>{milliToDate(todayDate())}</FontBoldText> is <FontBoldText>2:00 PM EDT</FontBoldText></div>
          <ContentWrap className="mt-20 mb-20" mL='0'>Date and time of receipt: <FontBoldText>{contribution.createdDate ? milliToDate(Number(contribution.createdDate)): todayDate()} at {contribution.createdDate ? milliToTime(Number(contribution.createdDate)) : '2:00 PM'}, EDT</FontBoldText></ContentWrap>
          { this.props.tradeCutoffDateAndTime && this.props.tradeCutoffDateAndTime.tradeCutoffDateAndTime ?
          <ContentWrap className="mt-20 mb-20" mL='0'>Trade cutoff for <FontBoldText>{milliToDate(this.props.tradeCutoffDateAndTime.tradeCutoffDateAndTime)}</FontBoldText> is <FontBoldText>2:00 PM, EDT</FontBoldText></ContentWrap>
          :
          <ContentWrap className="mt-20 mb-20" mL='0'>{this.props.tradeCutoffDateAndTime && this.props.tradeCutoffDateAndTime.message }</ContentWrap>
          }
          <ContentWrap className="mt-20 mb-20" mL='0'>Vanguard Mutual Funds that are received after the trade cutoff time listed above will most likely be processed on the following business day. For more information, please call the program at 888-383-4483 from 8:30 AM to 5:00 PM Eastern Time.</ContentWrap>
          </LetterOfAuthorization>
          : ''
        }
         { !isTypeChange && name === 'Asset Held at Vanguard - Securities' ?
        <LetterOfAuthorization width='true' className='mb-20'>
          <AuthorizationText>A signed Letter of Authorization (provided on the Funding Instructions page) will be required for the completion of this contribution.</AuthorizationText>
          </LetterOfAuthorization>
          : ''
        }
        <Row>
          <Col lg={{ span: 12 }} md={{ span: 12 }}>
            <Row>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Type</ContribType>
                <ContributionName >{ isTypeChange ? newType : name}</ContributionName>
              </Col>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Gift Id</ContribType>
                <ContributionName>
                  {contribution.giftId}
                </ContributionName>
              </Col>
            </Row>
            <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px"  />
          </Col>
        </Row>

        <Row>
          <Col lg={{ span: 12 }} md={{ span: 12 }}>
            <Row>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Source of Donation:</ContribType>
                <ContributionName>
                  {donorType}
                </ContributionName>
              </Col>

              { name === "Special Asset" && 
                <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                  <ContribType>Description:</ContribType>
                  <ContributionName>
                    {contribution && contribution.name ? contribution.name :  <div>&mdash;</div>}
                  </ContributionName>
                </Col>
              }
              
              {(name == "Check or Electronic Bank Transfer" || name == "Wire") ? 
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Dollar Amount</ContribType>
                <ContributionName >
                  { contribution.amount ? (transactionStatus === 'Reversed' ? '('+dollarAmount+')' : dollarAmount ) : <div>&mdash;</div>}
                </ContributionName>
              </Col>
              :  
              ((name === 'Asset Held at Vanguard - Mutual Funds') ? 
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Vanguard Account Number</ContribType>
                <ContributionName >
                {isSettlementFund ? (contribution.origBankAccountNumber ? contribution.origBankAccountNumber : <div>&mdash;</div>) :
                 (contribution.accountNumber ? contribution.accountNumber : <div>&mdash;</div>)}
                </ContributionName>
              </Col> 
              : 
              ((name === 'Asset Held at Vanguard - Securities') ? 
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType> {newType === 'VBS Security' ? 'Vanguard Account Number' : 'VBS Account Number'}</ContribType>
                <ContributionName >
                {contribution.accountNumber ? contribution.accountNumber : <div>&mdash;</div>}
                </ContributionName>
              </Col> : ''
              ))
              }
            </Row>
            <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px" />
          </Col>
        </Row>
        {
          (name === 'Asset Held Outside Vanguard - Mutual Funds' || name === 'Asset Held Outside Vanguard - Securities') ?
          <Row>
          <Col lg={{ span: 12 }} md={{ span: 12 }}>
            <Row>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Account Number</ContribType>
                <ContributionName>
                {contribution.accountNumber ? contribution.accountNumber : <div>&mdash;</div>}
                </ContributionName>
              </Col>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>{name === 'Asset Held Outside Vanguard - Mutual Funds' ? 'Holding Firm' : 'Brokerage Firm'}</ContribType>
                <ContributionName >
                {contribution.originatingFirmName ? contribution.originatingFirmName : <div>&mdash;</div>}
                </ContributionName>
              </Col>
            </Row>
            <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px" />
          </Col>
        </Row>
        : ''
        }
        { name === "Asset Held at Vanguard - Mutual Funds" ?
        <Row>
          <Col lg={{ span: 12 }} md={{ span: 12 }}>
            <Row>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Amount</ContribType>
                <ContributionName >
                { contribution.amount ? (transactionStatus === 'Reversed' ? '('+dollarAmount+')' : dollarAmount ) : <div>&mdash;</div>}
                </ContributionName>
              </Col>
            </Row>
            <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px"  />
          </Col>
        </Row>
      : ''}
        {(tickerValidations.includes(name) && !isMultiLot) ?
            <>
            <Row>
              <Col lg={{ span: 12 }} md={{ span: 12 }}>
                <Row>
                  <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                    <ContribType>{['Asset Held at Vanguard - Mutual Funds','Asset Held Outside Vanguard - Mutual Funds'].includes(name) ? 'Fund Name' :  'Security Name'}</ContribType>
                    <ContributionName>
                      {contribution.name ? contribution.name : <div>&mdash;</div>}
                    </ContributionName>
                  </Col>
                  <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                    <ContribType>{['Asset Held at Vanguard - Securities','Asset Held Outside Vanguard - Securities','Stock Certificates'].includes(name) ? 'Security Ticker' : 'Fund Ticker'}</ContribType>
                    <ContributionName >
                    {isSettlementFund ? (contribution.origBankName ? contribution.origBankName : <div>&mdash;</div>) :
                      (contribution.ticker ? contribution.ticker : <div>&mdash;</div>)}
                    </ContributionName>
                  </Col>
                </Row>
                <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px" />
              </Col>
            </Row>
            <Row>

            <Col lg={{ span: 12 }} md={{ span: 12 }}>
              <Row>
                <>
                {(['Asset Held at Vanguard - Mutual Funds','Asset Held Outside Vanguard - Mutual Funds'].includes(name)) ? 
                <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                  <ContribType>Fund Number</ContribType>
                  <ContributionName>
                  {isSettlementFund ? (contribution.wireReferenceNumber ? contribution.wireReferenceNumber : <div>&mdash;</div>) :
                      (name == 'Asset Held at Vanguard - Mutual Funds' ? contribution.fundNumber : contribution.nonVbsFundNumber)}
                  </ContributionName>
                </Col>
                : ''
                }
                
                <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                  <ContribType>Number of shares</ContribType>
                  <ContributionName >
                  {(isMutualStp ? (contribution.shares ? this.numberFormatter(contribution.shares) : <div>&mdash;</div>)
                   : (contribution.shares ? this.numberFormatter(contribution.shares) : (contribution.allShares ? 'All Shares' : <div>&mdash;</div>))
                  )}
                  </ContributionName>
                </Col>
                </>
              </Row>
              <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px" />
            </Col>
          </Row>
          </>
         : ''
        }
        {(name === 'Asset Held at Vanguard - Mutual Funds' && contribution.stpWorkflow == "Y" && contribution.allShares) ?
            <>
            <Row>
              <Col lg={{ span: 12 }} md={{ span: 12 }}>
                <Row>
                  <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                    <ContribType>All Shares</ContribType>
                    <ContributionName>
                     Yes
                    </ContributionName>
                  </Col>
                </Row>
                <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px" />
              </Col>
            </Row>
            
          </>
         : ''
        }
        <Row>
          <Col lg={{ span: 12 }} md={{ span: 12 }}>
            <Row>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Entered Date</ContribType>
                <ContributionName>
                  {contribution.createdDate ? milliToDate(Number(contribution.createdDate)) : <div>&mdash;</div>}
                </ContributionName>
              </Col>
              {!isMultiLot ?
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Settlement Date</ContribType>
                <ContributionName>
                  { settleDate ?  milliToDate(Number(settleDate)) : <div>&mdash;</div>}
                </ContributionName>
              </Col>
              : ''}
            </Row>
            <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px"  />
          </Col>
        </Row>
        
        <Row>
          <Col lg={{ span: 12 }} md={{ span: 12 }}>
            <Row>
            <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Received Date</ContribType>
                <ContributionName>
                  { /* LE-1721, The "Received Date" should be blank untill a CSR user receives the special asset */}
                  { contribution.receiveDateStr ? this.showReceivedDate(name, contribution) : <div>&mdash;</div>}
                </ContributionName>
              </Col>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Status</ContribType>
                <ContributionName>
                  {transactionStatus ? transactionStatus : <div>&mdash;</div> }
                </ContributionName>
              </Col>
            </Row>
            <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px"  />
          </Col>
        </Row>
        {tickerValidations.includes(name) && !isMultiLot ?
        <>
        {(!['Asset Held at Vanguard - Mutual Funds'].includes(name)) ?
        <>
          <Row>
            <Col lg={{ span: 12 }} md={{ span: 12 }}>
              <Row>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                  <ContribType>Sale Price</ContribType>
                  <ContributionName>
                  { lotDetails && lotDetails.price ? '$'+this.numberFormatter(lotDetails.price) : <div>&mdash;</div>}
                  </ContributionName>
                </Col>
                <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                  <ContribType>Sales Fee</ContribType>
                  <ContributionName>
                  { lotDetails && lotDetails.commissionFees ? formatter({
      value: lotDetails.commissionFees,
      fieldSuffix: "Dollars"
    }) : <div>&mdash;</div>}
                  </ContributionName>
                </Col>
              </Row>
              <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px"  />
            </Col>
          </Row>
          <Row>
            <Col lg={{ span: 12 }} md={{ span: 12 }}>
              <Row>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                  <ContribType>Processing Fee</ContribType>
                  <ContributionName>
                  { lotDetails && lotDetails.otherFees ? formatter({
      value: lotDetails.otherFees,
      fieldSuffix: "Dollars"
    }) : <div>&mdash;</div>}
                  </ContributionName>
                </Col>
                <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                  <ContribType>Sale Date</ContribType>
                  <ContributionName>
                  {soldDate ? milliToDate(Number(soldDate)) : <div>&mdash;</div> }
                  </ContributionName>
                </Col>
              </Row>
              <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px"  />
            </Col>
          </Row>
         
        <Row>
            <Col lg={{ span: 12 }} md={{ span: 12 }}>
              <Row>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                  <ContribType>Net Proceeds</ContribType>
                  <ContributionName>
                  { lotDetails && lotDetails.netProceeds ? formatter({
      value: lotDetails.netProceeds,
      fieldSuffix: "Dollars"
    }) : <div>&mdash;</div>}
                  </ContributionName>
                </Col>
              </Row>
              <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px"  />
            </Col>
          </Row>
          </> : ''
        }
        </> : ''
        }
        { isMultiLot ? 
          contribution.lotDetails.map((singleLot) => this.renderSingleLot(singleLot))
        : ''
        }
      {(donorType === "Individual" || donorType === "Joint") ? (
        <>
        <Row>
          <Col lg={{ span: 12 }} md={{ span: 12 }}>
            <Row>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Donor</ContribType>
                <ContributionName paddingBottom="20px">
                  {loggedInUserName}
                </ContributionName>
              </Col>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Donor Address</ContribType>
                <ContributionName>{address1}</ContributionName>
                <ContributionName>{removePeriod(address2)}</ContributionName>
              </Col>
            </Row>
              <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px"  />
          </Col>
        </Row>
        <Row>
           <Col lg={{ span: 12 }} md={{ span: 12 }}>
            <Row>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Address Type</ContribType>
                <ContributionName>
                  {addressType}
                </ContributionName>
              </Col>
            </Row>
            {donorType !== "Individual" || showAction ? (
              <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px"  />
            ) : null}
            </Col>
        </Row>
        </>
        )
        : null}
        {donorType !== "Individual" ? (
          <>
          <Row>
            <Col lg={{ span: 12 }} md={{ span: 12 }}>
              <Row>
                <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                  <ContribType>Donor</ContribType>
                  <ContributionName paddingBottom="20px">
                    {donorUserName}
                  </ContributionName>
                </Col>
                <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                  <ContribType>Donor Address</ContribType>
                  <ContributionName>{donoraddress1}</ContributionName>
                  <ContributionName>{removePeriod(donoraddress2)}</ContributionName>
                </Col>
              </Row>
              <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px"  />
            </Col>
          </Row>
          <Row>
            {
              donorType == "Joint" ? 
          <Col lg={{ span: 12 }} md={{ span: 12 }}>
            <Row>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Address Type</ContribType>
                <ContributionName paddingBottom="20px">
                  {donoraddressType}
                </ContributionName>
              </Col>
            </Row>
            {showAction ? (
              <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px"  />
            ) : null}
          </Col>
          :null
  }
        </Row>
        </>
        ) : null}
        { showAction ? (
          <>
          <Row>
            <Col lg={{ span: 12 }} md={{ span: 12 }}>
              <Row>
                <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                  <ContribType>Action</ContribType>
                  <ContributionName paddingBottom="20px">
                    {actionNeeded}
                  </ContributionName>
                </Col>
              </Row>
            </Col>
          </Row>
        </>
        ) : null}
        <ComponentDivider top='20px' mobileTop='30px' bottom="40px" mobileBottom="30px" />
      </div>
    );
  };

  render() {
    const { contributionTypes } = this.props;
    return contributionTypes ? (
      <>
        {(contributionTypes.securities && contributionTypes.securities.length) ? 
          contributionTypes.securities.map((security, index) =>
              this.renderContributionTypes(
                security,
                "Securities",
                contributionTypes.donorDisplayName,
                contributionTypes.donorDisplayAddress,
                index + 1,
                contributionTypes
              )
            )
            : ''
        }
        {(contributionTypes.funds && contributionTypes.funds.length) ? 
          contributionTypes.funds.map((fund, index) =>
              this.renderContributionTypes(
                fund,
                "Funds",
                contributionTypes.donorDisplayName,
                contributionTypes.donorDisplayAddress,
                index + 1,
                contributionTypes
              )
            )
          : ''}
        {(contributionTypes.checks && contributionTypes.checks.length)
          ? contributionTypes.checks.map((check, index) =>
              this.renderContributionTypes(
                check,
                "Check or Electronic Bank Transfer",
                contributionTypes.donorDisplayName,
                contributionTypes.donorDisplayAddress,
                index + 1,
                contributionTypes
              )
            )
          : null}
        {(contributionTypes.wires && contributionTypes.wires.length) ? 
          contributionTypes.wires.map((wire, index) =>
              this.renderContributionTypes(
                wire,
                "Wire",
                contributionTypes.donorDisplayName,
                contributionTypes.donorDisplayAddress,
                index + 1,
                contributionTypes
              )
            )
          : null}
        {(contributionTypes.specialAssets && contributionTypes.specialAssets.length)
          ? contributionTypes.specialAssets.map((stock, index) =>
              this.renderContributionTypes(
                stock,
                "Special Asset",
                contributionTypes.donorDisplayName,
                contributionTypes.donorDisplayAddress,
                index + 1,
                contributionTypes
              )
            )
          : null}
      </>
    ) : null;
  }
}

ContributionType.propTypes = {
  contributionTypes: PropTypes.array,
  dropDownData: PropTypes.array
}

const mapStateToProps = state => ({
  ...contributionTypeState(state.toJS())
});

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(ContributionType)
);
